import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { UiSpaBookingDTO, UiSpaTicketDTO } from '@api';
import { BookingUtils } from '@utils';

@Component({
  selector: 'spa-booking-status',
  templateUrl: './booking-status.component.html',
  styleUrls: ['./booking-status.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingStatusComponent {
  booking = input<UiSpaBookingDTO>();
  tickets = input<UiSpaTicketDTO[] | undefined>();

  status = computed(() => {
    return this.getBookingStatus(this.booking(), this.tickets());
  });

  getBookingStatus = BookingUtils.getBookingStatus;
}
